var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('el-col',{attrs:{"span":16}},[_c('div',{staticStyle:{"width":"1000px","height":"600px"},attrs:{"id":"main"}})]),_c('el-col',{attrs:{"span":6}},[_c('p',[_vm._v("欢迎登录")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }